import React from 'react';
import { Box, Typography } from '@mui/material';
export default function CustomerModificationAudit({event}) {
  let data=event;
  if(typeof event==='string') {try{data=JSON.parse(event);}catch(_){return event || '-';}}
  if(data?.schema!=='customer-modification-v1') return typeof event==='string'?event:'-';
  return <Box sx={{overflowWrap:'anywhere',minWidth:0}}>
    <Typography>{data.action} — {data.outcome}</Typography>
    <Typography>Admin: {data.admin_name || 'Unauthenticated'} (ID {data.admin_id || 'unavailable'}, {data.admin_role || 'unknown'})</Typography>
    <Typography>Customer ID: {data.target_user_id} · Request: {data.request_id || '—'}</Typography>
    {Object.entries(data.after || {}).map(([key,value])=><Typography key={key}>{key.replaceAll('_',' ')}: {data.before?.[key] || 'Not set'} → {value || 'Not set'}</Typography>)}
    {data.reason && <Typography>Reason: {data.reason}</Typography>}
    <Typography variant="caption" component="p">{data.occurred_at} · Event {data.event_uuid} · Correlation {data.correlation_id}</Typography>
    {data.notification && <Typography>Notification: {data.notification}</Typography>}
  </Box>;
}
